<template>
<div id="index">

  <div class="common-seach-wrap">
    <el-form size="small" :inline="true" :model="searchObj">
      <el-form-item label="门店名称">
        <el-input v-model="searchObj.search" placeholder="请输入门店名称"></el-input>
      </el-form-item>
      <el-form-item label="门店分类">
        <el-select v-model="searchObj.category_id" placeholder="请选择门店分类">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="item in cateList" :key="item.id" :label="item.name" :value="item.category_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="城市">
        <el-select v-model="searchObj.city_id" placeholder="请选择城市">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.city_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="门店服务">
        <el-select v-model="searchObj.service_id" placeholder="请选择门店服务">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="item in serviceList" :key="item.id" :label="item.name" :value="item.service_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="首页推荐">
        <el-select v-model="searchObj.is_home" placeholder="请选择首页推荐">
          <el-option label="全部" value=""></el-option>
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="pageChange(1)">查询</el-button>
      </el-form-item>
    </el-form>
  </div>


  <div class="common-level-rail">
    <el-button size="small" type="primary" @click="$refs.addEdit.show()" icon="el-icon-plus" v-auth="'/league/store/add'">添加门店</el-button>
  </div>

  <div class="product-content">
    <div class="table-wrap">
      <el-table size="small" :data="list">
        <el-table-column prop="name" label="门店名称"></el-table-column>
        <el-table-column prop="category.name" label="门店分类" ></el-table-column>
        <el-table-column  label="门店服务">
          <template slot-scope="scope">
            {{scope.row.service.map(item=>item.name).join('、')}}
          </template>
        </el-table-column>
        <el-table-column prop="city.name" label="城市"></el-table-column>
        <el-table-column prop="address" label="门店地址"></el-table-column>
        <el-table-column prop="logo" label="logo">
          <template slot-scope="scope">
            <el-image :src="scope.row.logo.file_path" fit="fill" :preview-src-list="[scope.row.logo.file_path]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="营业执照">
          <template slot-scope="scope">
            <el-image :src="scope.row.license.file_path" fit="fill" :preview-src-list="[scope.row.license.file_path]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="门店图片" width="220px">
          <template slot-scope="scope">
            <el-image v-for="(item,index) in scope.row.images.slice(0,3)" :key="index" :src="item.file_path" fit="fill" :preview-src-list="scope.row.images.map(item=>item.file_path)" ></el-image>
            <span v-if="scope.row.images.length>3">更多...</span>
          </template>
        </el-table-column>
        <el-table-column prop="opening_hour" label="营业时间"></el-table-column>
        <el-table-column prop="is_home" label="首页推荐">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.is_home?'success':'danger'">{{scope.row.is_home?'是':'否'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column prop="create_time" label="添加时间"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="$refs.addEdit.show(scope.row)" type="text" size="small" v-auth="'/league/store/edit'">编辑</el-button>
            <el-button @click="deleteTap(scope.row)" type="text" size="small" v-auth="'/league/store/delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>

  <div class="pagination">
    <el-pagination
      @current-change="pageChange"
      background
      :current-page="searchObj.page"
      :page-size="searchObj.list_rows"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>


  <AddEdit ref="addEdit" @refresh="getData" :cateList="cateList" :serviceList="serviceList" :cityList="cityList"></AddEdit>


</div>
</template>

<script>
import AddEdit from './addEdit.vue';
import LeagueApi from '@/api/league'
export default {
  components:{AddEdit},
  data() {
    return {
      searchObj:{
        page:1,
        list_rows:10,
        search:'',
        category_id:'',
        city_id:'',
        service_id:'',
        is_home:'',
      },
      list: [],
      total:0,
      cateList:[],
      serviceList:[],
      cityList:[],
    }
  },
  created(){
    this.getData()
    LeagueApi.categoryAll().then(result=>{
      this.cateList=result.data.category
    })
    LeagueApi.serviceAll().then(result=>{
      this.serviceList=result.data.service
    })
    LeagueApi.cityAll().then(result=>{
      this.cityList=result.data.list
    })
  },
  methods:{

    getData(){
      LeagueApi.storeIndex(this.searchObj).then(result=>{
        let list=result.data.list
        this.list=list.data
        this.total=list.total
      })
    },

    // 删除
    deleteTap(e){
      this.$confirm('确认删除当前门店吗？','提示',{type: 'warning'}).then(() => {
        LeagueApi.storeDelete({store_id:e.store_id}).then(result=>{
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getData()
        })
      })
    },

    // 分页
    pageChange(e){
      this.searchObj.page=e
      this.getData()
    },

  }
}
</script>

<style lang="scss" scoped>
.el-image{width: 50px;height: 50px;}
</style>


// WEBPACK FOOTER //
// src/views/league/store/index.vue